import React from 'react';
import classNames from 'classnames';
import LoadingSpinner from '../../loading-spinner';
import './document-loading-spinner.scss';

export const DocumentLoadingSpinner = ({ className }: { className?: string }) => (
  <div className={classNames('document-loading-spinner', className)}>
    <LoadingSpinner />
  </div>
);
